<template>
  <div>
    <Form ref="searchForm" inline :label-width="80" class="search-form">
      <Form-item label="赠送对象">
        <Input style="width:200px" placeholder="请输入赠送对象关键字" v-model="searchCondition.uname" clearable @keydown.native.prevent.enter="search(1)"/>
      </Form-item>
      <Form-item label="优惠券名称">
        <Input style="width:200px" placeholder="请输入优惠券名称关键字" v-model="searchCondition.name" clearable @keydown.native.prevent.enter="search(1)"/>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" :to="{name: 'CouponUse'}">赠送优惠券</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/handSel/coupon"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
        keyField="id"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="open(row)">查看详情-</Button>
          <Button
            type="text"
            size="small"
            @click="cancelPresent(row)"
          >{{row.status == 1?"撤销赠送":"已经撤销"}}</Button>
          <!-- >{{"row.status" == 1?"撤销赠送":"已经撤销"}}</Button> -->
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "CouponManage",
  data() {
    return {
      column: [
        {
          title: "优惠券名称",
          key: "coupon",
          align: "center",
          minWidth: 200
        },
        {
          title: "赠送对象",
          key: "names",
          align: "center",
          minWidth: 200
        },
        {
          title: "赠送日期",
          key: "created_at",
          align: "center",
          minWidth: 180
        },
        {
          title: "使用/赠送",
          key: "draw_status",
          align: "center",
          minWidth: 140
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: 'right'
        }
      ],
      selectList: [],
      searchCondition: {
        uname: "",
        name: ""
      }
    };
  },
  methods: {
    search(flag) {
      if (flag == 0) {
        this.searchCondition.name = "";
        this.searchCondition.uname = "";
      }
      this.$refs.grid.searchRefresh();
    },
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToDay(i.created_at);
        i.draw_status = i.used + "/" + i.user_num;
      });
    },
    open(row) {
      this.$router.push({
        name: "PresentDetail",
        query: { id: row.id }
      });
    },
    cancelPresent(row) {
      if (row.status == 1) {
        this.$Modal.confirm({
          title: "提示",
          content:
            "撤销赠送后学员的优惠券将失效，已经使用的优惠券不受影响，确定撤销么？",
          onOk: async () => {
            await this.$http.put(`/api/handSel/cancelHandSel/${row.id}`);
            this.$refs.grid.searchRefresh()
          }
        });
      } else {
        return;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
